(function () {
  'use strict';

  let optionsDataPromise = null;

  function loadOptions(url) {
    if (!optionsDataPromise) {
      optionsDataPromise = fetch(url).then((res) => res.json());
    }
    return optionsDataPromise;
  }

  function populateSelect(select, values, placeholder, placeholderIsSelectable) {
    select.innerHTML = '';
    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    placeholderOption.selected = true;
    placeholderOption.disabled = !placeholderIsSelectable;
    select.appendChild(placeholderOption);
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }

  function initSelector(root) {
    const sectionId = root.dataset.sectionId;
    const configEl = document.getElementById('VehicleSelectorConfig-' + sectionId);
    if (!configEl) return;
    const config = JSON.parse(configEl.textContent);

    const makeSelect = root.querySelector('[data-vehicle-make]');
    const modelSelect = root.querySelector('[data-vehicle-model]');
    const yearSelect = root.querySelector('[data-vehicle-year]');
    const categorySelect = root.querySelector('[data-vehicle-category]');
    const submitButton = root.querySelector('[data-vehicle-submit]');
    const form = root.querySelector('[data-vehicle-form]');

    loadOptions(config.optionsUrl)
      .then((data) => {
        root.vehicleData = data;
        populateSelect(makeSelect, Object.keys(data).sort(), 'Select make');
        makeSelect.disabled = false;
      })
      .catch(() => {
        root.classList.add('vehicle-selector--error');
      });

    function resetFrom(level) {
      if (level <= 2) {
        populateSelect(modelSelect, [], 'Select model');
        modelSelect.disabled = true;
      }
      if (level <= 3) {
        populateSelect(yearSelect, [], 'Select year');
        yearSelect.disabled = true;
      }
      if (level <= 4) {
        populateSelect(categorySelect, [], 'All categories', true);
        categorySelect.disabled = true;
      }
      updateSubmitState();
    }

    makeSelect.addEventListener('change', () => {
      const models = root.vehicleData[makeSelect.value] || {};
      populateSelect(modelSelect, Object.keys(models).sort(), 'Select model');
      modelSelect.disabled = false;
      resetFrom(3);
    });

    modelSelect.addEventListener('change', () => {
      const models = root.vehicleData[makeSelect.value] || {};
      const years = Object.keys(models[modelSelect.value] || {})
        .map(Number)
        .sort((a, b) => b - a);
      populateSelect(yearSelect, years, 'Select year');
      yearSelect.disabled = false;
      resetFrom(4);
    });

    yearSelect.addEventListener('change', () => {
      const models = root.vehicleData[makeSelect.value] || {};
      const years = models[modelSelect.value] || {};
      const categories = years[yearSelect.value] || [];
      populateSelect(categorySelect, categories, 'All categories', true);
      categorySelect.disabled = false;
      updateSubmitState();
    });

    categorySelect.addEventListener('change', updateSubmitState);

    function updateSubmitState() {
      submitButton.disabled = !(makeSelect.value && modelSelect.value && yearSelect.value);
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (submitButton.disabled) return;
      const params = new URLSearchParams({
        make: makeSelect.value,
        model: modelSelect.value,
        year: yearSelect.value,
      });
      if (categorySelect.value) params.set('category', categorySelect.value);
      window.location.href = config.resultsUrl + '?' + params.toString();
    });
  }

  document.querySelectorAll('[data-vehicle-selector]').forEach(initSelector);
})();
